import { render, staticRenderFns } from "./videoResources.vue?vue&type=template&id=af7492f2&scoped=true&"
import script from "./videoResources.vue?vue&type=script&lang=js&"
export * from "./videoResources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af7492f2",
  null
  
)

export default component.exports